import React from "react";

export const ACTIVITY_CALENDAR_MODE = "calendar";
export const ACTIVITY_LIST_MODE = "list";

export default class AccrualViewToggler extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            viewMode: props.viewMode === ACTIVITY_CALENDAR_MODE ? ACTIVITY_CALENDAR_MODE : ACTIVITY_LIST_MODE
        };

        this._onButtonClick = this._onButtonClick.bind(this);
    }

    /**
     * 
     * @param {*} evt 
     */
    _onButtonClick(viewMode) {
        if (viewMode !== this.state.viewMode) {
            this.setState({ viewMode });
            if (this.props.onViewModeChange) this.props.onViewModeChange(viewMode);
        }
    }

    render() {
        /** 
         * @type {{ selected: "list" | "calendar", className:  string }} 
         * */
        const props = this.props;
        const state = this.state;
        const viewMode = state.viewMode;
        const activeClass = "btn btn-info-active";
        const inactiveClass = "btn btn-info-inactive";
        const listClass = !viewMode || viewMode === ACTIVITY_LIST_MODE ? activeClass : inactiveClass;
        const calendarClass = viewMode === ACTIVITY_CALENDAR_MODE ? activeClass : inactiveClass;
        const isVisibleClass = props.isVisible === false ? "hidden" : "";

        return (
            <div className={`btn-group btn-group-xs ap-ap-accrual-view-toggler ${isVisibleClass} ${props.className || ""}`}>
                <button type="button" title="List View" className={listClass} onClick={() => this._onButtonClick(ACTIVITY_LIST_MODE)}>
                    <i className="fa fa-list"></i>
                </button>
                <button type="button" title="Calendar View" className={calendarClass} onClick={() => this._onButtonClick(ACTIVITY_CALENDAR_MODE)}>
                    <i className="fa fa-calendar"></i>
                </button>
            </div>
        );
    }
}